import { AiOutlineHome, AiOutlineFundProjectionScreen } from "react-icons/ai"
import { CgFileDocument } from "react-icons/cg"
import { Home, Projects, Resume } from '../pages'

export const LANGUAGES = ['en', 'pt']

export const ROUTES = [
    { to: '/', label: 'index', Icon: AiOutlineHome, Page: Home },
    { to: '/projects', label: 'projects', Icon: AiOutlineFundProjectionScreen, Page: Projects },
    { to: '/resume', label: 'resume', Icon: CgFileDocument, Page: Resume },
]